module.exports = __webpack_public_path__ + "static/Place-Des-Carmes-LONG-INTRO-480p-MP4-fa22ad09b8098a4e2602cf7827f1978c.mp4";